<template>
  <v-row id="occupancy-graph-header">
    <div>
      <span class="occupancy-title">
        Occupancy <a
          href="https://help.noiseaware.io/hc/en-us/articles/5641387258003-CrowdControl-Support"
          target="_blank"
        >
          <v-icon
            color="muted"
            size="16"
          >$faInfoCircle</v-icon>
        </a>
      </span>
    </div>
    <router-link
      class="caption-2"
      :to="{ name: 'Account Settings' }"
    >
      Manage Occupancy Alerts
    </router-link>
  </v-row>
</template>

<script>
  export default {
    name: 'OccupancyGraphHeader',
  }
</script>

<style lang="scss">
#occupancy-graph-header {
  margin: 25px 0 15px 0;
  justify-content: space-between;
}

.occupancy-title {
  font-size: 18px;
  color: #7e7e7e;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: center;
  margin: 0 4px;
}
.caption-2 {
    color: #456e6c;
    text-transform: uppercase;
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 12px;
    letter-spacing: 1.5px;
    text-align: left;
    margin: auto 25px auto 0;
    text-decoration: none;
}

</style>
